import styled from 'styled-components'

export const Text = styled.p`
    text-align: center;
    margin-top: 10px;
`
